import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { CardLoadingIndicator } from '../../../../../components/new-card-loader';
import { IncidentsTileConsts } from './constants'

const IncidentTileComponent = React.lazy(() => import(/* webpackChunkName:"im-card" */'./index'));

export const IncidentTile = () => {
    return (
        <LazyLoadComponentWrapper
            fallback={<CardLoadingIndicator error={false} cardTitle={IncidentsTileConsts.cardTitle} />}
            errorIndicator={<CardLoadingIndicator error={true} cardTitle={IncidentsTileConsts.cardTitle} />}>
            <IncidentTileComponent uiid='single-ui-incident-tile'/>
        </LazyLoadComponentWrapper>
    );
};
